import React, { useState, useEffect } from "react";

//CSS
import "./tagPopups.css";
import "../0PageStyles.css";

//Components
import ColorCircle from "../../Components/Tag Components/colorCircle";
import Button from "../../Components/Other Components/button";
import InputField from "../../Components/Other Components/inputField";
import PageLoader from "../../Components/Other Components/pageLoader";
import MandatoryExplanation from "../../Components/Other Components/mandatoryExplanation";

//Functions and hooks
import { GetNextTagID, CreateTag } from "../../BackendAccess/TagHooks";
import { useNotification } from "../../Contexts/NotificationContext";
import { useErrorHandler } from "../../hooks/errorHandler";
import { useTranslation } from "react-i18next";

export default function TagCreationPopup({ onCancel, onCreate }) {
  const [ID, setID] = useState();
  const [Name, setName] = useState();
  const [Color, setColor] = useState("hsl(0,0%,100%)");
  const [Description, setDescription] = useState();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);

  const [createBtnDisabled, setCreateBtnDisabled] = useState(false);

  const { showNotification } = useNotification();

  useErrorHandler(error, showNotification, setPageError);

  const { t } = useTranslation();

  useEffect(() => {
    const fetchInitialValues = async () => {
      setLoading(true);
      try {
        const [nextID, error] = await GetNextTagID();
        if (error) {
          error.isPageError = true;
          setError(error);
          return;
        }
        setID(nextID);
      } catch (err) {
        setError({
          err: t("server.Server error.", { ns: "error" }),
          errCode: 500,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchInitialValues();
  }, []);

  const handleIDChange = (e) => {
    const value = e;

    setID(value);
  };
  const handleNameChange = (e) => {
    const value = e;
    setName(value);
  };
  const handleColorChange = (e) => {
    const value = e;
    setColor(value);
  };
  const handleDescriptionChange = (e) => {
    const value = e;
    setDescription(value);
  };

  const OnCreate = async () => {
    setCreateBtnDisabled(true);
    showNotification(
      t("Tag creation in progress...", { ns: "tags" }),
      "success"
    );
    try {
      const [data, error] = await CreateTag(ID, Name, Color, Description);

      if (error) {
        setError(error);
        return;
      }
      await onCreate();
      showNotification(
        t("Tag created successfully!", { ns: "tags" }),
        "success"
      );
      onCancel();
    } catch (err) {
      setError({
        err: t("server.Server error.", { ns: "error" }),
        errCode: 500,
      });
    } finally {
      setCreateBtnDisabled(false);
    }
  };

  const clickOnCancel = () => {
    showNotification(t("Tag creation canceled.", { ns: "tags" }), "info");
    onCancel();
  };
  return (
    <div className="input-popup">
      <div className="dimming-cover" />
      <div className="input-popup-container">
        <PageLoader loading={loading} error={pageError}>
          <div className="input-popup-fields-container tags">
            <InputField
              placeholder={t("Example: 1001")}
              label={t("ID") + ":"}
              value={ID}
              onChange={handleIDChange}
              mandatory={true}
              readOnly={true}
            />
            <InputField
              placeholder={t("Example: Metal items", { ns: "tags" })}
              label={t("Name") + ":"}
              value={Name}
              onChange={handleNameChange}
              mandatory={true}
            />
            <ColorCircle
              color={Color}
              onChange={handleColorChange}
            ></ColorCircle>
          </div>
          <div className="input-popup-fields-container tags-description">
            <InputField
              className="mb-0"
              placeholder={t(
                "Example: The items with this tag are made out of metal.",
                { ns: "tags" }
              )}
              label={t("Description") + ":"}
              value={Description}
              onChange={handleDescriptionChange}
            />
          </div>
          <MandatoryExplanation />

          <div className="btn-container">
            <Button
              btnMargin={"btn-default"}
              btnStyle="btn-positive"
              onClick={OnCreate}
              acceptEnter={true}
              disabled={createBtnDisabled}
              icon={"create"}
            >
              {t("Create")}
            </Button>
            <Button
              btnMargin={"btn-default"}
              btnStyle="btn-primary"
              onClick={clickOnCancel}
            >
              {t("Cancel")}
            </Button>
          </div>
        </PageLoader>
      </div>
    </div>
  );
}
